export type CustomerStatus = "Aktif" | "Pasif" | "Sorunlu" | "Yasaklı";
export type Gender = "Kadın" | "Erkek";

export interface Customer {
  id: string;
  fullName: string;
  phone: string;
  email: string;
  gender: Gender;
  birthDate: string;
  source: string;
  status: CustomerStatus;
  totalVisits: number;
  lastVisitDate: string;
  totalSpent: number;
  openPayment: number;
  activePackage: boolean;
  remainingSessions: number;
  satisfactionNote: string;
  privateNotes: string;
  address: string;
  createdAt: string;
}

export const customers: Customer[] = [
  {
    id: "cus-001",
    fullName: "Ayşe Yılmaz",
    phone: "+90 532 123 4567",
    email: "ayse.yilmaz@email.com",
    gender: "Kadın",
    birthDate: "1985-03-15",
    source: "Google",
    status: "Aktif",
    totalVisits: 12,
    lastVisitDate: "2026-05-01",
    totalSpent: 14500,
    openPayment: 0,
    activePackage: true,
    remainingSessions: 4,
    satisfactionNote: "Her zaman çok memnun, personeli çok seviyor.",
    privateNotes: "Sırt ağrısı problemi var, masaj sırasında hassas.",
    address: "Ataşehir, İstanbul",
    createdAt: "2025-01-10",
  },
  {
    id: "cus-002",
    fullName: "Mehmet Demir",
    phone: "+90 533 987 6543",
    email: "mehmet.demir@email.com",
    gender: "Erkek",
    birthDate: "1978-07-22",
    source: "Tekrar Müşteri",
    status: "Aktif",
    totalVisits: 28,
    lastVisitDate: "2026-05-04",
    totalSpent: 34200,
    openPayment: 0,
    activePackage: true,
    remainingSessions: 7,
    satisfactionNote: "Yıllardır düzenli geliyor, çok sadık müşteri.",
    privateNotes: "VIP müşteri, özel ilgi gösterilmeli.",
    address: "Kadıköy, İstanbul",
    createdAt: "2024-06-15",
  },
  {
    id: "cus-003",
    fullName: "Elif Kaya",
    phone: "+90 534 555 1122",
    email: "elif.kaya@email.com",
    gender: "Kadın",
    birthDate: "1992-11-08",
    source: "WhatsApp",
    status: "Aktif",
    totalVisits: 5,
    lastVisitDate: "2026-04-20",
    totalSpent: 6800,
    openPayment: 2500,
    activePackage: false,
    remainingSessions: 0,
    satisfactionNote: "Paket almayı düşünüyor, memnuniyeti yüksek.",
    privateNotes: "Hediye paketine ilgisi var, teklif edilecek.",
    address: "Beşiktaş, İstanbul",
    createdAt: "2026-02-14",
  },
  {
    id: "cus-004",
    fullName: "Burak Şahin",
    phone: "+90 535 333 7788",
    email: "burak.sahin@email.com",
    gender: "Erkek",
    birthDate: "1990-01-30",
    source: "Meta",
    status: "Aktif",
    totalVisits: 1,
    lastVisitDate: "",
    totalSpent: 0,
    openPayment: 750,
    activePackage: false,
    remainingSessions: 0,
    satisfactionNote: "İlk ziyaret",
    privateNotes: "Reklamdan geldi, dönüşüm takip edilecek.",
    address: "Şişli, İstanbul",
    createdAt: "2026-05-06",
  },
  {
    id: "cus-005",
    fullName: "Zeynep Arslan",
    phone: "+90 536 444 9999",
    email: "zeynep.arslan@email.com",
    gender: "Kadın",
    birthDate: "1988-09-12",
    source: "Tavsiye",
    status: "Aktif",
    totalVisits: 15,
    lastVisitDate: "2026-05-02",
    totalSpent: 18700,
    openPayment: 1100,
    activePackage: true,
    remainingSessions: 2,
    satisfactionNote: "Tavsiye üzerine geldi, artık düzenli.",
    privateNotes: "Paketi bitmek üzere, yenileme teklifi yapılacak.",
    address: "Üsküdar, İstanbul",
    createdAt: "2025-04-20",
  },
  {
    id: "cus-006",
    fullName: "Can Özdemir",
    phone: "+90 537 666 2233",
    email: "can.ozdemir@email.com",
    gender: "Erkek",
    birthDate: "1995-05-18",
    source: "Google",
    status: "Aktif",
    totalVisits: 3,
    lastVisitDate: "2026-04-10",
    totalSpent: 2400,
    openPayment: 600,
    activePackage: false,
    remainingSessions: 0,
    satisfactionNote: "Düzenli randevu alıyor, memnun.",
    privateNotes: "Ayak tırnak problemi devam ediyor, uzmana yönlendirilecek.",
    address: "Maltepe, İstanbul",
    createdAt: "2026-01-05",
  },
  {
    id: "cus-007",
    fullName: "Selin Çelik",
    phone: "+90 538 777 3344",
    email: "selin.celik@email.com",
    gender: "Kadın",
    birthDate: "1983-12-03",
    source: "Tekrar Müşteri",
    status: "Aktif",
    totalVisits: 32,
    lastVisitDate: "2026-05-03",
    totalSpent: 45600,
    openPayment: 0,
    activePackage: true,
    remainingSessions: 1,
    satisfactionNote: "En sadık müşterilerimizden, çok değerli.",
    privateNotes: "Paketi son seans, VIP muamelesi. Yenileme %20 indirim teklif edilecek.",
    address: "Etiler, İstanbul",
    createdAt: "2023-09-10",
  },
  {
    id: "cus-008",
    fullName: "Ahmet Koç",
    phone: "+90 539 888 5566",
    email: "ahmet.koc@email.com",
    gender: "Erkek",
    birthDate: "1980-04-25",
    source: "WhatsApp",
    status: "Aktif",
    totalVisits: 8,
    lastVisitDate: "2026-04-28",
    totalSpent: 8900,
    openPayment: 0,
    activePackage: false,
    remainingSessions: 0,
    satisfactionNote: "Sporcu masajından çok memnun.",
    privateNotes: "Düzenli olarak koşu sonrası masaj istiyor.",
    address: "Sarıyer, İstanbul",
    createdAt: "2025-08-01",
  },
  {
    id: "cus-009",
    fullName: "Nur Aydın",
    phone: "+90 530 999 6677",
    email: "nur.aydin@email.com",
    gender: "Kadın",
    birthDate: "1975-06-14",
    source: "Tavsiye",
    status: "Aktif",
    totalVisits: 6,
    lastVisitDate: "2026-04-22",
    totalSpent: 10200,
    openPayment: 0,
    activePackage: true,
    remainingSessions: 3,
    satisfactionNote: "Doktor önerisiyle geldi, sonuçlardan memnun.",
    privateNotes: "Medikal masaj alıyor, düzenli kontrol önemli.",
    address: "Bakırköy, İstanbul",
    createdAt: "2025-11-15",
  },
  {
    id: "cus-010",
    fullName: "Ece Yıldız",
    phone: "+90 531 111 8899",
    email: "ece.yildiz@email.com",
    gender: "Kadın",
    birthDate: "1990-02-28",
    source: "Meta",
    status: "Aktif",
    totalVisits: 2,
    lastVisitDate: "2026-03-15",
    totalSpent: 1800,
    openPayment: 1300,
    activePackage: false,
    remainingSessions: 0,
    satisfactionNote: "Düğün hazırlıkları için düzenli gelecek.",
    privateNotes: "Düğün öncesi program planlanacak.",
    address: "Bağdat Caddesi, İstanbul",
    createdAt: "2026-02-20",
  },
  {
    id: "cus-011",
    fullName: "Deniz Kara",
    phone: "+90 532 222 9900",
    email: "deniz.kara@email.com",
    gender: "Kadın",
    birthDate: "1993-08-19",
    source: "Tekrar Müşteri",
    status: "Aktif",
    totalVisits: 18,
    lastVisitDate: "2026-05-05",
    totalSpent: 15600,
    openPayment: 0,
    activePackage: true,
    remainingSessions: 5,
    satisfactionNote: "Her ay düzenli bakım yaptırıyor.",
    privateNotes: "Jel tırnak takviyesi favorisi, stok kontrol edilmeli.",
    address: "Moda, İstanbul",
    createdAt: "2024-11-01",
  },
  {
    id: "cus-012",
    fullName: "Gökhan Yılmaz",
    phone: "+90 533 333 0011",
    email: "gokhan.yilmaz@email.com",
    gender: "Erkek",
    birthDate: "1987-10-07",
    source: "Google",
    status: "Sorunlu",
    totalVisits: 4,
    lastVisitDate: "2026-04-01",
    totalSpent: 3200,
    openPayment: 2200,
    activePackage: false,
    remainingSessions: 0,
    satisfactionNote: "Son 3 randevusuna gelmedi.",
    privateNotes: "SON 3 RANDEVUYA GELMEDİ. KAPORA ALMADAN RANDEVU VERMEYİN. WhatsApp teyitli randevulara da gelmedi.",
    address: "Pendik, İstanbul",
    createdAt: "2026-01-20",
  },
];